import React from 'react';
import { useContext } from 'react';
import { Search } from '../shared/Search';
import { AttendeeObjectSelector } from './AttendeeObjectSelector';
import { SearchContext } from './AttendeeSearchContainer';
import '../searchContainer/SearchBar.scss';

export const AttendeeSearchBar = () => {
  const context = useContext(SearchContext);

  return (
    <div
      className={'searchBar-container'}
      id='searchBar'>
      <AttendeeObjectSelector />
      <Search
        className={'searchBar-input'}
        searchQuery={context.searchQuery}
        onSearchCallback={context.searchQueryCallback}
        searchPlaceholder={`Search for Attendee(s)...`}
      />
    </div>
  );
};
